import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSendEmail3 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "send-email-3" }), /* @__PURE__ */ _jsx("path", { d: "M23.854.2A.5.5,0,0,0,23.3.091L.3,9.99a.5.5,0,0,0-.036.9l6.67,3.531A.249.249,0,0,0,7.21,14.4L17.5,6.1a.25.25,0,0,1,.352.352l-8.3,10.29a.249.249,0,0,0-.026.274l3.531,6.67a.5.5,0,0,0,.442.266h.019a.5.5,0,0,0,.439-.3l10-22.9A.5.5,0,0,0,23.854.2Z" })]
});
export default SvgSendEmail3;
